export function trackById<T extends { id: number }>(_index: number, t: T): number {
  return t.id;
}
